import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["action", "avatar", "avatarCircular", "clickable", "description", "icon", "iconColor", "loading", "title"];

/* eslint-disable react/no-array-index-key */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ChevronForward } from '@mediahuis/chameleon-theme-wl/icons';
import system from '../../../system';
import Avatar from '../../Avatar';
import Flex from '../../Flex';
import Box from '../../Box';
import Icon from '../../Icon';
import Text from '../../Text';
import styles from './index.module.scss';
import Skeleton from '../../Skeleton';
var SYSTEM_PROPS = ['marginProps', 'floatProps', 'flexProps'];
var WideListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classNames;

  var action = _ref.action,
      avatar = _ref.avatar,
      avatarCircular = _ref.avatarCircular,
      clickable = _ref.clickable,
      description = _ref.description,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      loading = _ref.loading,
      title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  var extendedProp = clickable ? {
    as: rest.as || 'button'
  } : {};
  var classNames = (_classNames = {}, _classNames[styles.root] = true, _classNames[styles.clickable] = clickable, _classNames[styles.loading] = loading, _classNames);
  return /*#__PURE__*/React.createElement(Flex, _extends({}, rest, extendedProp, {
    className: cx(classNames, className),
    style: style,
    ref: ref,
    justifyContent: "space-between",
    alignItems: "center",
    width: "full"
  }), loading ? /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.skeleton
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    mr: action ? 4 : 0
  }, !avatar && icon && /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    as: icon,
    color: iconColor,
    mr: 5,
    className: styles.icon
  }), avatar && /*#__PURE__*/React.createElement(Avatar, {
    circular: avatarCircular,
    src: avatar,
    className: styles.avatar,
    mr: 5
  }), /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Text, {
    fontWeight: "medium",
    fontFamily: "system",
    size: "Heading6",
    display: "block",
    color: "blackBase",
    as: "span"
  }, title), description && /*#__PURE__*/React.createElement(Text, {
    fontFamily: "system",
    size: "Caption2",
    display: "block",
    color: "grey60",
    as: "span",
    fontWeight: "regular",
    mt: 1
  }, description))), !clickable && /*#__PURE__*/React.createElement(Box, {
    as: "span",
    flexShrink: 0
  }, action), clickable && /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    as: ChevronForward,
    color: "grey50",
    ml: 5,
    className: styles.icon
  })));
});
WideListItem.displayName = 'WideListItem';
WideListItem.identifier = WideListItem.displayName; // used in docs website

WideListItem.clonableProps = SYSTEM_PROPS;
WideListItem.defaultProps = {};
export default WideListItem;